import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { twJoin } from '@/lib/utils'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { m } from '@/lib/paraglide/messages'

// sourceChanged: the order moved on since the draft was saved (warning).
// Otherwise the draft only carries invoice-side edits and the reset is offered
// quietly as the way back to the order's own lines.
export function EInvoiceDraftReset({
    pending,
    sourceChanged,
    onReset,
}: {
    pending: boolean
    sourceChanged: boolean
    onReset: () => Promise<void>
}) {
    const [open, setOpen] = useState(false)
    return (
        <div
            className={twJoin(
                'space-y-3 rounded-md border p-4 text-sm',
                sourceChanged
                    ? 'border-amber-300 bg-amber-50'
                    : 'bg-muted/40 text-muted-foreground',
            )}
        >
            <p>
                {sourceChanged
                    ? m.einvoice_draft_source_changed()
                    : m.einvoice_draft_edited()}
            </p>
            <Button
                type="button"
                variant="outline"
                disabled={pending}
                onClick={() => setOpen(true)}
            >
                {m.einvoice_draft_reset()}
            </Button>
            <Dialog
                open={open}
                onOpenChange={(value) => {
                    if (!pending) setOpen(value)
                }}
            >
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>
                            {m.einvoice_draft_reset_title()}
                        </DialogTitle>
                        <DialogDescription>
                            {m.einvoice_draft_reset_hint()}
                        </DialogDescription>
                    </DialogHeader>
                    <div className="flex flex-wrap justify-end gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            disabled={pending}
                            onClick={() => setOpen(false)}
                        >
                            {m.einvoice_draft_reset_cancel()}
                        </Button>
                        <Button
                            type="button"
                            disabled={pending}
                            onClick={() => {
                                void onReset().then(() => setOpen(false))
                            }}
                        >
                            {m.einvoice_draft_reset_confirm()}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}
